import { useEffect } from "react";
import { setActiveModule, ActiveModule } from "../providers/active-module";
import { useConfig } from "../providers/config";
import { queryClient } from "../config/query-client";
import { useIonAlert } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

const useForceToGoNewVersion = () => {
  const config = useConfig();
  const history = useHistory();
  const { t } = useTranslation();
  const [presentAlert] = useIonAlert();

  const handleClearCache = async () => {
    await queryClient.clear();
  };

  useEffect(() => {
    if (config.forceToGoNewVersion) {
      presentAlert({
        header: t("New version is available"),
        backdropDismiss: false,
        keyboardClose: false,
        buttons: [
          {
            text: t("Update"),
            handler: () => {
              const newActiveModule = {
                current: config.moduleOnInit,
                isModuleInitialized: true,
              } as ActiveModule;

              setActiveModule(newActiveModule);
              handleClearCache();
              window.location.reload();
              history.replace("/");
            },
          },
        ],
      });
    }
  }, []);
};

export default useForceToGoNewVersion;
